// extracted by mini-css-extract-plugin
module.exports = {"leftArea":"TimelineTopMenuArea_leftArea__3BSMg","navBtn":"TimelineTopMenuArea_navBtn__2KpUJ"};